import React, { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import Logo from '../../img/fpg_logo.png'; // Make sure this path is right!

export default function PageHeader() {
  const location = useLocation(); // Get current URL path
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  // --- RESPONSIVE STATE ---
  // Tracks if the screen is smaller than 768px (standard mobile/tablet breakpoint)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  // Tracks if the hamburger menu is currently open
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
    setDropdownOpen(false);
  }, [location.pathname]);

  // Helper to check active state
  const isActive = (path) => location.pathname === path;

  // --- STYLES ---
  // Note: I moved styles inside the component so they can dynamically react to `isMobile`
  const styles = {
    navBar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '80px',
      backgroundColor: '#0b132b', 
      borderBottom: '1px solid #1c2b4d', 
      padding: isMobile ? '0 20px' : '0 40px', // Less padding on mobile
      color: '#f8fafc',
      position: 'relative',
      zIndex: 1000,
      boxShadow: '0 4px 20px rgba(0,0,0,0.4)', 
    },
    navGroupDesktop: {
      display: 'flex',
      gap: '30px', 
      alignItems: 'center',
    },
    // MOBILE SPECIFIC: Takes over the screen below the header
    navGroupMobile: {
      display: isMenuOpen ? 'flex' : 'none', // Only show if hamburger is clicked
      flexDirection: 'column',
      position: 'absolute',
      top: '80px', // Sits exactly below the navbar
      left: 0,
      width: '100%',
      backgroundColor: '#0b132b',
      padding: '20px 0',
      borderBottom: '1px solid #1c2b4d',
      boxShadow: '0 10px 20px rgba(0,0,0,0.5)',
      gap: '20px',
    },
    linkText: {
      textDecoration: 'none',
      color: '#cbd5e1', 
      fontSize: '16px', 
      fontWeight: '600', 
      textTransform: 'uppercase', 
      letterSpacing: '1px',
      display: 'block',
      textAlign: isMobile ? 'center' : 'left', // Center text on mobile
    },
    activeLink: {
      color: '#b026ff', 
      fontWeight: 'bold',
    },
    hamburgerBtn: {
      display: isMobile ? 'block' : 'none',
      background: 'none',
      border: 'none',
      color: '#f8fafc',
      fontSize: '28px',
      cursor: 'pointer',
    },
    dropdownContainer: {
      position: 'relative',
      cursor: 'pointer',
      textAlign: 'center',
    },
    dropdownMenu: {
      position: isMobile ? 'relative' : 'absolute', // Inline on mobile, floating on desktop
      top: isMobile ? '10px' : '100%', 
      left: isMobile ? '0' : '-10px',
      backgroundColor: isMobile ? 'transparent' : '#111c3a', 
      minWidth: '160px',
      boxShadow: isMobile ? 'none' : '0px 10px 25px rgba(0,0,0,0.6)',
      borderRadius: '4px',
      padding: '10px 0',
      display: 'flex',
      flexDirection: 'column',
      border: isMobile ? 'none' : '1px solid #2a3b61', 
      alignItems: 'center',
    },
    dropdownItem: {
      padding: '10px 20px',
      textDecoration: 'none',
      color: '#e2e8f0', 
      display: 'block',
      fontSize: '16px',
    }
  };

  return (
    <div style={styles.navBar}>
      {/* LOGO AREA */}
      <Link to="/home">
        <img src={Logo} style={{ height: '50px', width: 'auto' }} alt="Foreplay Games" />
      </Link>

      {/* HAMBURGER BUTTON (Only visible on mobile) */}
      <button 
        style={styles.hamburgerBtn} 
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        {isMenuOpen ? '✕' : '☰'} 
      </button>

      {/* NAVIGATION AREA */}
      <div style={isMobile ? styles.navGroupMobile : styles.navGroupDesktop}>
        
        <Link to="/home" style={{ ...styles.linkText, ...(isActive('/home') ? styles.activeLink : {}) }}>
          Home
        </Link>

        {/* GAMES DROPDOWN */}
        <div 
          style={styles.dropdownContainer}
          // On Desktop: Hover opens it. On Mobile: Clicking toggles it.
          onMouseEnter={() => !isMobile && setDropdownOpen(true)}
          onMouseLeave={() => !isMobile && setDropdownOpen(false)}
          onClick={() => isMobile && setDropdownOpen(!isDropdownOpen)}
        >
          <span style={{ ...styles.linkText, ...(location.pathname.includes('/games') ? styles.activeLink : {}) }}>
            Games {isDropdownOpen ? '▴' : '▾'}
          </span>

          {isDropdownOpen && (
            <div style={styles.dropdownMenu}>
              <Link to="/games/3xr" style={styles.dropdownItem}>
                3XRay
              </Link>
              <Link to="/games/lonelyhands" style={styles.dropdownItem}>
                LonelyHands
              </Link>
            </div>
          )}
        </div>

        <Link to="/devlog" style={{ ...styles.linkText, ...(isActive('/devlog') ? styles.activeLink : {}) }}>
          Devlog
        </Link>

        <Link to="/jobs" style={{ ...styles.linkText, ...(isActive('/jobs') ? styles.activeLink : {}) }}>
          Jobs
        </Link>

        <Link to="/faq" style={{ ...styles.linkText, ...(isActive('/faq') ? styles.activeLink : {}) }}>
          FAQ
        </Link>

        {/* <Link to="/ai-policy" style={{ ...styles.linkText, ...(isActive('/ai-policy') ? styles.activeLink : {}) }}>
          AI Policy
        </Link> */}

      </div>
    </div>
  );
}